















import { Vue, Component, Prop } from 'vue-property-decorator'
import store from 'src/assets/store'
import confirm from 'components/modals/Confirm'
import api from 'src/assets/api/gql'
import ItemUpdate from 'src/graphql/item/ItemUpdate.gql'
import { Item } from 'src/graphql/types'

@Component
export default class PresenterLayoutMenuButtonPublish extends Vue {

  get item () {
    return store.state.presenter.item!
  }

  async action () {
    await confirm({
      title: this.item.courseTopicPublic ? this.$t('item.publish.off').toString() : this.$t('item.publish.on').toString(),
      message: this.item.name
    })
    const item = this.item
    const { data: { updateItem } } = await api.mutate({
      query: ItemUpdate,
      variables: {
        id: this.item.id,
        data: {
          courseTopicPublic: !this.item.courseTopicPublic
        }
      }
    })
    if (updateItem && updateItem.item) {
      store.presenterSetItem(updateItem.item)
    }
  }
}
